import * as React from 'react';
import * as moment from 'moment-timezone';
import { Text } from 'wix-ui-tpa';
import WeeklyDotsHeader from './WeeklyDotsHeader';
import { st, classes } from './WeeklyMobileDatesHeader.st.css';
import { getCurrentWeek } from '../../../utils/momentTimezoneUtils';
import capitalize from '../../../utils/stringUtils';
import WeeklyContextMobile from '../../../context/weeklyContextMobile';
var WeeklyMobileDatesHeader = function () {
    var _a = React.useContext(WeeklyContextMobile), dateOnFocuse = _a.dateOnFocuse, setCurrentWeekRange = _a.setCurrentWeekRange, locale = _a.locale, firstDay = _a.firstDay, setHeaderPickerDate = _a.setHeaderPickerDate;
    React.useEffect(function () {
        setCurrentWeekRange(getCurrentWeek(firstDay, dateOnFocuse, locale));
    }, [firstDay, dateOnFocuse, locale]);
    return (React.createElement("div", { className: classes.DatesWrapper }, getCurrentWeek(firstDay, dateOnFocuse, locale).map(function (_a, index) {
        var day = _a.day, date = _a.date, isToday = _a.isToday, eventDate = _a.eventDate, momentDate = _a.momentDate;
        var inFocuse = moment(momentDate).format('YYYY-MM-DD') ===
            moment(dateOnFocuse).format('YYYY-MM-DD');
        return (React.createElement("div", { key: index },
            React.createElement("div", { className: classes.WeekDayWrapper },
                React.createElement(Text, { className: st(classes.WeekDay, { isToday: isToday }) }, capitalize(day, true))),
            React.createElement("button", { className: st(classes.WeekDateWrapper, { isToday: isToday, inFocuse: inFocuse }), onClick: function () {
                    setHeaderPickerDate(moment(momentDate).format());
                } },
                React.createElement(Text, { className: st(classes.WeekDate, { isToday: isToday }) }, date),
                React.createElement(WeeklyDotsHeader, { eventDate: eventDate, isToday: isToday }))));
    })));
};
export default WeeklyMobileDatesHeader;
//# sourceMappingURL=WeeklyMobileDatesHeader.js.map